import { apiSuccessSchema, meDataSchema } from "@metaadsmanager/tk-master-contracts";
import { queryOptions } from "@tanstack/react-query";

import { apiClient } from "../api/browser-client";

/**
 * 为当前 Better Auth 用户创建独立的身份与 Workspace 查询缓存。
 * 不转发 AbortSignal：见 app-query-client 模块头注释（StrictMode / canceled）。
 */
export const meQueryOptions = (userId: string | undefined) =>
  queryOptions({
    queryKey: ["me", userId],
    queryFn: () => apiClient.get("/v1/me", apiSuccessSchema(meDataSchema)),
    staleTime: 30_000,
  });
